import sortBy from 'lodash/sortBy';
import { metricKeys } from '@pulse/metrics';

// Add metrics for compare dashboard this will be updated with future draggable component
const metricsOrder = [
  metricKeys.Attempts,
  metricKeys.Plays,
  metricKeys.VideoStartFailures,
  metricKeys.VideoStartFailuresPercentage,
  metricKeys.RebufferingRatio,
  metricKeys.ExitBeforeVideoStarts,
  metricKeys.ExitBeforeVideoStartsPercentage,
  metricKeys.ConnectionInducedRebufferingRatio,
  metricKeys.VideoStartTime,
  metricKeys.Bitrate,
  metricKeys.VideoRestartTime,
  metricKeys.Framerate,
  metricKeys.VideoPlaybackFailures,
  metricKeys.VideoPlaybackFailuresPercentage,
  metricKeys.EndedPlays,
  metricKeys.ConcurrentPlays,
  metricKeys.SpiStreams,
  metricKeys.StreamingPerformanceIndex,
  metricKeys.HighExitBeforeVideoStart,
  metricKeys.VideoStartFailuresTech,
  metricKeys.HighStartupTime,
  metricKeys.HighRebuffering,
  metricKeys.LowBitrate,
  metricKeys.VideoPlaybackFailuresTech,
  metricKeys.VideoPlaybackFailuresTechPer1000PlayingMinutes,
  metricKeys.ExitDueToCIR,
  metricKeys.LifeDropFrameRatio,
];

const sortMetricsByOrder = (metrics) => {
  const order = (item) => {
    const index = metricsOrder.indexOf(item);
    return (index > -1 ? index : 1000);
  };

  return sortBy(metrics, [order]);
};

export { metricsOrder, sortMetricsByOrder };
